import NiceModal from '@ebay/nice-modal-react'

import { PrintScriptModalProps } from '../PrintScriptModal/helpers'

import { HeadersFootersModal } from './HeadersFootersModal'

export const showHeadersFootersModal = (params: PrintScriptModalProps) => {
  NiceModal.show(HeadersFootersModal, {
    enableDuration:
      params.docType === 'script' && params.script.type !== 'screenplay',
  })
}
